<template>
<tile-vidget
	:title="station.shortName ? station.shortName : station.name"
	:style="station.isActive ? '' : 'filter: grayscale(100%);'"
	class="station-tile p-1"
>
	<div class="row m-0 m-1 p-0">
		<div class="col-auto">
			<!-- Modem unit -->
			<unit-icon v-if="unitsConnection.modemUnit == null"/>
			<unit-icon
				v-else
				unitType="modem"
				:color="connectionColor(unitsConnection.modemUnit)"
			/>
		</div>
		<div class="col-auto">
			<!-- Power unit -->
			<unit-icon v-if="unitsConnection.powerUnit == null"/>
			<unit-icon
				v-else
				unitType="power"
				:color="connectionColor(unitsConnection.powerUnit)"
			/>
		</div>
		<div class="col-auto">
			<!-- Service unit -->
			<unit-icon v-if="unitsConnection.serviceUnit == null"/>
			<unit-icon
				v-else
				unitType="service"
				:color="connectionColor(unitsConnection.serviceUnit)"
			/>
		</div>
		<div class="col-auto">
			<!-- Electric meter unit -->
			<unit-icon v-if="unitsConnection.powerMeterUnit == null"/>
			<unit-icon
				v-else
				unitType="power_meter"
				:color="connectionColor(unitsConnection.powerMeterUnit)"
			/>
		</div>
		<div class="col-auto">
			<!-- No connection time counter -->
			<span 
				v-if="unitsConnection.modemUnit !== null"
				class="ms-2"
				:class="{'conn-ok': unitsConnection.modemUnit, 'conn-err': !unitsConnection.modemUnit}"
			>
				{{ unitsConnection.modemUnit === true ?
					`${fixNumberPrecision(station.modem_unit.connectionQuality, 0)}%` :
					`${timeFromNowPromt(station.getFormatedMetric(ModemUnit.metricKeys.lastConnection, 'modem'))}`
				}}
			</span>
		</div>
	</div>
	<div class="row m-0 p-0 my-1">
		<div class="col-6 mx-0 ps-2 text-start metric-name-text">
			Вихідний струм
		</div>
		<div class="col-6 mx-0 pe-2 text-end metric-value-text">
			{{ station.power_unit.getMetricValue(PowerUnit.metricKeys.iOut, 2) }}
		</div>
	</div>
	<div class="row m-0 p-0 my-1">
		<div class="col-6 mx-0 ps-2 text-start metric-name-text">
			Вихідна напруга
		</div>
		<div class="col-6 mx-0 pe-2 text-end metric-value-text">
			{{ station.power_unit.getMetricValue(PowerUnit.metricKeys.uOut, 2) }}
		</div>
	</div>
	<div class="row m-0 p-0 my-1">
		<div class="col-6 mx-0 ps-2 text-start metric-name-text">
			Захисний потенціал
		</div>
		<div class="col-6 mx-0 pe-2 text-end metric-value-text">
			<!-- {{ replaceEmptyMetric(station.power_unit, PowerUnit.metricKeys.eOut, 2) }} -->
			{{ uProtect ? uProtect : 'не відстежується' }}
		</div>
	</div>
	<div class="row m-0 p-0 my-1">
		<div class="col-6 mx-0 ps-2 text-start metric-name-text">
			Напруга
		</div>
		<div class="col-6 mx-0 pe-2 text-end metric-value-text">
			{{ replaceEmptyMetric(station.service_unit, ServiceUnit.metricKeys.u220, 2) }}
		</div>
	</div>
</tile-vidget>
</template>




<script>
import TileVidget from "@/components/Vidgets/TileVidget.vue"
import UnitIcon from '@/components/Icons/UnitIcon.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { Station } from '@/models/station'
import { PowerUnit } from '@/models/powerUnit.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { ModemUnit } from '@/models/modemUnit.js'
// import { ElectricMeter } from "@/models/electricMeter.js"
import {
	fixNumberPrecision,
	connectionColor,
	timeFromNowPromt,
} from '@/helpers.js'

export default {
	components: {
		TileVidget,
		UnitIcon,
	},

	props: {
		station: {
			type: Object,
			required: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		
		return {
			accountStore,
			Station,
			PowerUnit,
			ServiceUnit,
			ModemUnit,
			fixNumberPrecision,
			connectionColor,
			timeFromNowPromt,
		}
	},

	methods: {
		replaceEmptyMetric(unit, metricId, fract=2) {
			if (unit.getMetricValue(metricId, fract) == '') {
				return '-'
			} else {
				return unit.getMetricValue(metricId, fract)
			}
		},
	},

	computed: {
		unitsConnection() {
			return {
				powerUnit: 
					this.station.passport.get(Station.passportKeys.powerUnit.self)[Station.passportKeys.powerUnit.unitVersion] == PowerUnit.versions.unknown ?
					null :
					this.station.power_unit.isConnect,
				serviceUnit: 
					this.station.passport.get(Station.passportKeys.serviceUnit.self)[Station.passportKeys.serviceUnit.unitVersion] == ServiceUnit.versions.unknown ?
					null :
					this.station.service_unit.isConnect,
				modemUnit:
					this.station.passport.get(Station.passportKeys.modemUnit.self)[Station.passportKeys.modemUnit.unitVersion]
						== ModemUnit.versions.unknown ?
					null :
					this.station.modem_unit.isConnect,
				powerMeterUnit:
					this.station?.electricMeterIsSeparateUnit ?
					this.station.electricMeter.isConnect :
					null,
			}
		},

		uProtect() {
			switch(this.station.uProtectSource) {
				case null:
					return undefined
				case 'power': {
					const metric = this.station?.getMetric(PowerUnit.metricKeys.eOut, 'power')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				case 'service': {
					const metric = this.station?.getMetric(ServiceUnit.metricKeys.eAvg, 'service')
					return typeof metric == 'object' ? metric.value.toFixed(2) : undefined
				}
				default:
					return undefined
			}
		},
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style scoped>
	.station-tile {
		min-width: 23em;
		max-height: 14rem;
		box-shadow: 4px 4px 4px 1px rgba(36,41,46,.122);
	}
</style>